module.exports = __webpack_public_path__ + "img/home_logistics.6dac714f.png";